/* eslint-disable max-len */
import React from "react";
import { Modal, Form, Button, Dropdown } from "react-bootstrap";
import PropTypes from "prop-types";
import NumberFormat from "react-number-format";
import flag from "../../assets/admin/aus-flag.png";
import us from "../../assets/admin/us-flag.png";

const AddBilingContact = ({
  showContactModal,
  handleContactModal,
  handleContactData,
  handleAddBillingContact,
  contactData,
  error,
  selectedCountry,
  handleCountry,
}) => (
  <Modal
    size="lg"
    show={showContactModal}
    onHide={handleContactModal}
    aria-labelledby="contained-modal-title-vcenter"
    top
    className="staff-modal"
  >
    <div className="staff-close">
      <i
        className="fa fa-times"
        onClick={handleContactModal}
        aria-hidden="true"
      />
    </div>
    <Modal.Header>
      <Modal.Title id="contained-modal-title-vcenter">
        Associated Billing Contact
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className="staff-form">
        <Form>
          <div className="row">
            <div className="col-md-12">
              <Form.Group controlId="formBasicInput-1" className="italic-text">
                <Form.Label>
                  {" "}
                  Contact First Name
                  {/* <span className="required-field">*</span> */}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  onChange={handleContactData}
                  placeholder="Enter First Name"
                  value={contactData.name}
                  className={`${error === "firstname" ? "error-text" : ""}`}
                />
              </Form.Group>
            </div>
            <div className="col-md-12">
              <Form.Group controlId="formBasicInput-1" className="italic-text">
                <Form.Label>
                  Contact Last Name
                  {/* <span className="required-field">*</span> */}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="lastName"
                  onChange={handleContactData}
                  value={contactData.lastName}
                  placeholder="Enter Last Name"
                  className={`${error === "lastname" ? "error-text" : ""}`}
                />
              </Form.Group>
            </div>
            <div className="col-md-12">
              {/* <Form.Group controlId="formBasicInput-1" className="italic-text">
                <Form.Label>
                </Form.Label>
                <Form.Control
                  type="number"
                  name="mobileNo"
                  onChange={handleContactData}
                  value={contactData.mobileNo}
                  placeholder="Enter Mobile Number"
                  className={`${
                    error === 'mobileno'
                      ? 'error-text'
                      : ''
                  }`}
                />
              </Form.Group> */}
              <Form.Group
                controlId="formBasicInput-3"
                className="number italic-text"
              >
                <Form.Label>Mobile No.</Form.Label>
                <div className="number-field">
                  {/* <Form.Label className="special-label">Phone Input</Form.Label> */}
                  <div className="number-box">
                    <Dropdown id="mobile">
                      <Dropdown.Toggle variant="success" id="dropdown-basic1">
                        <div className="flag-icon">
                          <img
                            src={selectedCountry === "+61" ? flag : us}
                            alt="flag"
                          />
                        </div>
                        {selectedCountry === "+61" ? (
                          <span>Australia {selectedCountry}</span>
                        ) : selectedCountry === "+1" ? (
                          <span>United States {selectedCountry}</span>
                        ) : (
                          ""
                        )}
                        <span>
                          <i className="fas fa-caret-down" />
                        </span>
                        {/* <div className="country-code">{selectedCountry}</div> */}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item
                          id="12"
                          onClick={() => handleCountry("+61")}
                        >
                          <div className="flag-icon">
                            <img src={flag} alt="flag" />
                          </div>
                          <div className="country-code">
                            <span>Australia</span> +61
                          </div>
                        </Dropdown.Item>
                        <Dropdown.Item
                          id="122"
                          onClick={() => handleCountry("+1")}
                        >
                          <div className="flag-icon">
                            <img src={us} alt="flag" />
                          </div>
                          <div className="country-code">
                            <span>United States</span> +1
                          </div>
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <NumberFormat
                    className={`form-control mobile-num ${
                      error === "mobileno" ? "error-text" : ""
                    }`}
                    format="### ### ###"
                    onChange={handleContactData}
                    name="mobileNo"
                    value={contactData.mobileNo}
                    placeholder="Enter Mobile Number"
                    autocomplete="off"
                  />
                </div>
              </Form.Group>
            </div>
            <div className="col-md-12">
              {/* <Form.Group controlId="formBasicInput-1">
                <Form.Label>Landline No.</Form.Label>
                <Form.Control
                  type="number"
                  name="landlineNo"
                  onChange={handleContactData}
                  value={contactData.landlineNo}
                  className={`${
                    error === 'landlineno'
                      ? 'error-text'
                      : ''
                  }`}
                />
              </Form.Group> */}
              <Form.Group controlId="formBasicInput-3" className="number">
                <Form.Label>Landline No.</Form.Label>
                <div className="number-field">
                  {/* <Form.Label className="special-label">Phone Input</Form.Label> */}
                  <div className="number-box">
                    <Dropdown id="mobile">
                      <Dropdown.Toggle variant="success" id="dropdown-basic1">
                        <div className="flag-icon">
                          <img
                            src={selectedCountry === "+61" ? flag : us}
                            alt="flag"
                          />
                        </div>
                        {selectedCountry === "+61" ? (
                          <span>Australia {selectedCountry}</span>
                        ) : selectedCountry === "+1" ? (
                          <span>United States {selectedCountry}</span>
                        ) : (
                          ""
                        )}
                        <span>
                          <i className="fas fa-caret-down" />
                        </span>
                        {/* <div className="country-code">{selectedCountry}</div> */}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item
                          id="12"
                          onClick={() => handleCountry("+61")}
                        >
                          <div className="flag-icon">
                            <img src={flag} alt="flag" />
                          </div>
                          <div className="country-code">
                            <span>Australia</span> +61
                          </div>
                        </Dropdown.Item>
                        <Dropdown.Item
                          id="122"
                          onClick={() => handleCountry("+1")}
                        >
                          <div className="flag-icon">
                            <img src={us} alt="flag" />
                          </div>
                          <div className="country-code">
                            <span>United States</span> +1
                          </div>
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <NumberFormat
                    className={`form-control mobile-num ${
                      error === "landlineNo" ? "error-text" : ""
                    }`}
                    format="### ### ###"
                    onChange={handleContactData}
                    name="landlineNo"
                    value={contactData.landlineNo}
                    placeholder="Enter Landline Number"
                    autocomplete="off"
                  />
                </div>
              </Form.Group>
            </div>
            <div className="col-md-12">
              <Form.Group controlId="formBasicInput-1" className="italic-text">
                <Form.Label>
                  Email Address
                  {/* <span className="required-field">*</span> */}
                </Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  onChange={handleContactData}
                  value={contactData.email}
                  placeholder="Enter Email Address"
                  className={`${error === "email" ? "error-text" : ""}`}
                />
              </Form.Group>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="view-btn">
                <Button className="btn btn-edit" onClick={handleContactModal}>
                  Cancel
                </Button>
                <Button
                  className="btn btn-save"
                  onClick={handleAddBillingContact}
                >
                  Save/Update
                </Button>
              </div>
            </div>
          </div>
        </Form>
      </div>
    </Modal.Body>
  </Modal>
);

AddBilingContact.propTypes = {
  showContactModal: PropTypes.bool.isRequired,
  handleContactModal: PropTypes.func.isRequired,
  handleContactData: PropTypes.func.isRequired,
  handleAddBillingContact: PropTypes.func.isRequired,
  contactData: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired,
  selectedCountry: PropTypes.string.isRequired,
  handleCountry: PropTypes.func.isRequired,
};

export default AddBilingContact;
